import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=bef2866c&scoped=true&"
import script from "./basicInfo.vue?vue&type=script&lang=ts&"
export * from "./basicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=bef2866c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef2866c",
  null
  
)

export default component.exports